import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { useTheme } from "../../../../hooks";
import spinTheWheelBannerImage from "../../../../components/images/spin-the-wheel-banner-Img.png";
import { Button, DynamicButton, StyledText } from "../../../../components/common/basic";
import { MainHolder } from "../../../../components/common/basic";
import { BackButton } from "../../../../components/common";
import { useHistory } from "react-router-dom";
import MashupNowButton from "../../mashupnwin/components/MashupNowButton";
import { NoticeIconNew } from "../../../../components/svgs";
import useSpeedShoppingPoints from "../../speedShopping/hooks/useSpeedShoppingPoints";
import loadingGif from "../../../../components/images/loader.gif";
import { useSpinTheWheelHome } from "../hooks";
import PointStatsModal from "../components/PointStatsModal";

const PointsBuildingRules = () => {
  const [showPointStatsModal, setShowPointStatsModal] = useState(false);
  const [showSpinBtn, setShowSpinBtn] = useState(false);
  const {
    userPoints,
    getLoyaltyPoints,
  } = useSpeedShoppingPoints();

  const history = useHistory();
  const { themeContext, theme } = useTheme();
  let themeColor = "background";
  let background = theme.colors[themeContext.activeTheme][themeColor];

  const { pointsRounded, isPromoEnded, isQualified, rank } = userPoints || {};

  const token = JSON.parse(localStorage.getItem("token"));

  const {
    requirePointsBuilding,
    spinTheWheelData,
  } = useSpinTheWheelHome();

  const { details: { startDate } = {} } = spinTheWheelData || {};
  if (!requirePointsBuilding) {
    history.push('/spin_the_wheel/home')
  }

  useEffect(() => {
    getLoyaltyPoints({ payload: {} });
  }, []);

  useEffect(() => {
    if (
      pointsRounded !== -1 &&
      (new Date() >= new Date(startDate))
    ) {
      setShowPointStatsModal(true);
      if (isQualified) setShowSpinBtn(true);
    }
  }, [pointsRounded, startDate]);

  return (
    <>
      <MainHolder>
        <Image src={spinTheWheelBannerImage} />
        <Gradient>
          <GradientBody>
            <BackButton
              onClick={() => {
                history.push(`/home?token=${token}`);
              }}
            />
            <HeaderContent>
              <ContentContainer>
                <Button
                  style={{
                    background: "#FFCC00",
                    width: "96px",
                    height: "24px",
                    borderRadius: "5px",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    fontFamily: "MTNMedium",
                    fontSize: "12px",
                    marginBottom: "12px",
                  }}
                >
                  Gaming
                </Button>
                <StyledText
                  style={{
                    marginBlockStart: 0,
                    marginBlockEnd: 0,
                    paddingBottom: 10,
                  }}
                  size={26}
                  color={"white"}
                >
                  {"Spin the Wheel"}
                </StyledText>
                <StyledText
                  style={{
                    fontFamily: "MTNMedium",
                    marginBlockStart: 0,
                    marginBlockEnd: 0,
                    padding: 0,
                    width: "280px",
                  }}
                  size={15}
                  color={"white"}
                >
                  {"Spin to Win: Try your luck for instant rewards!"}
                </StyledText>
              </ContentContainer>
            </HeaderContent>
          </GradientBody>
        </Gradient>
        <Children>
          <CardContainer>
            {
              pointsRounded === -1 ? (
                <div>
                  <img
                    alt={"dialog"}
                    src={loadingGif}
                    style={{ width: "32px", margin: "0 auto" }}
                  />
                </div>
              )
                :
                <PointsCard>
                  <DescriptionText>Accumulated points</DescriptionText>
                  <PointsText>{pointsRounded}</PointsText>
                </PointsCard>
            }
            {/* <TimeContainer>
              <NoticeIconNew width="12" />
              <StyledText
                style={{
                  fontFamily: "MTNRegular",
                  display: "flex",
                  gap: "2px",
                }}
                size={10}
              >
                Point accumulation ends in
                <span style={{ fontWeight: "bold" }}>{CountdownTimer}</span>
              </StyledText>
            </TimeContainer> */}
            {
              isPromoEnded &&
              <TimeContainer>
                <NoticeIconNew width="12" />
                <StyledText
                  style={{
                    fontFamily: "MTNRegular",
                    display: "flex",
                    gap: "2px",
                  }}
                  size={10}
                >
                  Point accumulation has ended!
                </StyledText>
              </TimeContainer>
            }
          </CardContainer>
          <div
            style={{
              height: 1,
              width: "90vw",
              backgroundColor: "#C8CBCB",
              alignSelf: "center",
              margin: 15,
              marginLeft: 20,
            }}
          />
          <RulesContainer>
            <StyledText
              style={{
                marginBlockStart: 0,
                marginBlockEnd: 0,
                paddingBottom: 20,
              }}
              size={26}
            >
              {"Game Rules"}
            </StyledText>
            {tips.map((note, index) => {
              return (
                <TipsContainer key={index}>
                  <CircleContainer>
                    <Dot color={background} />
                  </CircleContainer>
                  <StyledText
                    size="14"
                    style={{ marginBlockStart: 0, fontFamily: "MTNMedium" }}
                  >
                    {note}
                  </StyledText>
                </TipsContainer>
              );
            })}
          </RulesContainer>

          {showSpinBtn &&
            <div style={{ margin: '0 auto', width: "90%" }}>
              <DynamicButton
                label={"Spin"}
                color={"#ffcc00"}
                onClick={() => history.push('/spin_the_wheel/home', { rank })}
                fullWidth
                textColor={"000"}
              />
            </div>
          }

          <MashupNowButton
            bgcolor="#ffcc00"
            label="Mashup"
            textColor="#333"
            width="90%"
            showLeaderboard
            leaderboardUrl="/spin_the_wheel/leaderboard"
          />
        </Children>
      </MainHolder>
      {showPointStatsModal && (
        <PointStatsModal
          rank={rank}
          isEligible={isQualified}
          onBackDropClick={() => setShowPointStatsModal(false)}
          onClose={() => setShowPointStatsModal(false)}
        />
      )}
    </>
  );
};

export default PointsBuildingRules;

const RulesContainer = styled.div`
  margin: 5%;
`;

const Children = styled.div`
  height: 100%;
  width: 100%;
`;

const Gradient = styled.div`
  width: 100%;
  height: 250px;
  background: linear-gradient(
    180deg,
    rgba(0, 0, 0, 0) 0%,
    rgba(0, 0, 0, 0.17) 39.58%,
    #000000 100%
  );
  //   position: absolute;
  z-index: 1;
  display: grid;
  grid-auto-flow: column;
  align-items: flex-start;
  padding: 5px 0;
`;

const Image = styled.img`
  height: 250px;
  width: 100%;
  margin: 0;
  position: absolute;
  object-fit: cover;
  object-position: -20px 10%;
`;

const GradientBody = styled.div`
  padding: 5px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 90%;
`;

const HeaderContent = styled.div`
  display: flex;
  align-content: start;
  align-items: flex-end;
  justify-content: flex-start;
  height: 100%;
  width: 100%;
`;

const CardContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 22vh;
`;

const PointsCard = styled.div`
  background-color: #333;
  color: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 90%;
  margin-top: 33px;
  height: 96px;
  border-radius: 10px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  text-align: center;
`;

const PointsText = styled.h1`
  font-size: 32px;
  margin: 0;
  font-family: "MTNBold";
`;

const CountDownText = styled.h1`
  margin: 0;
  font-family: "MTNMedium";
  font-size: 14px;
`;

const DescriptionText = styled.p`
  font-size: 16px;
  font-family: "MTNMedium";
  margin: 5px 0;
`;

const TimeContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
  width: 90%;
  margin-top: 10px;
`;

const ContentContainer = styled.div`
  margin-left: 10px;
  margin-right: 10px;
`;

const TipsContainer = styled.div`
  display: flex;
`;

const CircleContainer = styled.div`
  display: flex;
  align-items: flex-start;
  margin-right: 10px;
  margin-top: 5px;
`;

const Dot = styled.div`
  width: 15px;
  height: 15px;
  border-radius: 50%;
  background-color: #ffcc00;
  margin: 0;
  padding: 0;
`;

const tips = [
  "Earn points by mashing up. 0.05 GHS = 1 point.",
  "Accumulate points from November 27 to December 15, 2024.",
  "The leaderboard shows all participants their total points.",
  "Only top-ranked users on the leaderboard (e.g., top 10 or 100) are eligible for spins.",
  "Eligible users receive spins, with rewards linked to each spin.",
];
